import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { HTMLStripperAPI } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { exampleHTML } from "../../Services/Tools";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function HTMLStripper() {
    const [text, setText] = useState("");
    const [reqBody, setReqBody] = useState();
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'HTML Tag Remover', Iconpath: "/FileCodeRaw.svg" };
    const [, setIsValid] = useState(true);


    

    


    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        setText(e.target.value);
        setReqBody({
            html: e.target.value
        });
    };


    const formatHTML= () => {
            StripHTML();
    }

    const pasteExample = () => {
            setText(exampleHTML);
            setReqBody({
                html: exampleHTML,
            })
    };


    const handleImport = (filecontent) => {
        setText(filecontent);

        setReqBody({
            html: filecontent,
        });
    };

    const StripHTML = async () => {
        try {
            const response = await HTMLStripperAPI(reqBody);
            setresult(response.data.text);
            setIsValid(true);
        } catch (error) {
            if (error.response?.status === 400) {
                const apiMessage =
                    error.response?.data?.message;
                setresult(apiMessage);
                setIsValid(false);
            } else {
                setresult("Something went wrong. Please try again.");
                setIsValid(false);
            }
        }
    };

    
    return (
        <>
            <Col>
                <ToolHeader title="HTML Tag Remover" description="Remove HTML tags and get clean, plain text instantly" toolFav={toolFav} />

                <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input HTML"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your HTML here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setReqBody("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".html"
                                    executeLabel={"Format"}
                                    showExecute={true}
                                    onExecute={formatHTML}
                                />
                            }
                            footerLeft={`Characters : ${String(text ?? "").replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text ?? ""]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Stripped Text"
                            value={result ?? ""}
                            placeholder="Stripped plain text will appear here..."
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.html"
                                    mimeType="application/json;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${String(result ?? "").replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default HTMLStripper;
